<template>
<v-card>
  <v-card-title>
      <h3 class="admin-header">Organizations</h3>
      <v-btn text icon color="grey lighten-1" @click="refresh"><v-icon>fas fa-sync</v-icon></v-btn>
      <v-spacer></v-spacer>
        <v-select label="Deleted" v-model="deletedFilter" :items="deletedItems"></v-select>
      <v-spacer></v-spacer>
        <v-select label="SLA" v-model="slaFilter" :items="slas"></v-select>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="fal fa-search"
        placeholder="Search"
        single-line
        hide-details
        clearable
      ></v-text-field>
    </v-card-title>
  <v-data-table
    :options.sync="pagination"
    :headers="headers"
    :items="filteredOrgs"
    :search="search"
    :loading="loading"
    :footer-props="{'items-per-page-options': [5, 10, 15, 20, 50, 100]}"
    class="elevation-1"
  >
    <template v-slot:item.name="{item}">
      <td>
        <router-link :to="{ name: 'orgEdit', params: { id: item.id }}">
              {{ item.name }}</router-link >
      </td>
    </template>
    <template v-slot:item.createdDate="{item}">
      <td>{{ formatDateTime(item.createdDate) }}</td>
    </template>
    <template v-slot:item.updatedDate="{item}">
      <td>{{ formatDateTime(item.updatedDate) }}</td>
    </template>
    <template v-slot:item.actions="{item}">
      <td class="actions">
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn text icon :to="{ name: 'orgEdit', params: { id: item.id }}" v-on="on"
            style="height: 0px; width: 0px; padding-right:2px;">
              <v-icon color="grey lighten-1" style="font-size: 18px;">fas fa-pencil</v-icon>
            </v-btn >
          </template>
          <span>Edit</span>
        </v-tooltip>
    </td>
    </template>
    <v-alert slot="no-results" :value="true" color="error" type="warning">
        Your search for "{{ search }}" found no results.
    </v-alert>
  </v-data-table>

  <v-dialog v-model="newOrgDialog" max-width="600px" persistent>
          <v-card>
            <v-card-title>
              <span class="headline">Organization</span>
            </v-card-title>
            <v-card-text>
              <v-form v-model="validOrg" ref="orgForm" @submit.prevent>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.name" :rules="[rules.required]" label="Org Name *"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-autocomplete
                        :autofocus="false"
                        autocomplete="off"
                        v-model="editedItem.timeZone"
                        :items="timeZEntries"
                        label="Timezone"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.email" :rules="[rules.required, rules.formatEmail]" label="Admin Email *"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="domainName" disabled label="Domain *"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.firstName" :rules="[rules.required,]" label="Admin First Name *"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.lastName" :rules="[rules.required]" label="Admin Last Name *"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-btn text color="blue darken-1" @click.native="close">Cancel</v-btn>
              <v-btn text color="blue darken-1" :disabled="!validOrg" @click.native="saveNew">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

  <v-card-actions>
    <button class="btn btn-primary" @click="newOrg()">New Organization</button>
  </v-card-actions>


</v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import {TZ_DISPLAY_MAP_ORG} from '../../models/timezone.model'
import moment from 'moment'
import _ from 'lodash'
export default {
  data(){
      return {
        pagination: {
          rowsPerPage: 10,
          itemsPerPage: 10
        },
        editedItem: {
          id: -1,
          name: '',
          domainName: '',
          email: '',
          firstName: '',
          lastName: '',
          timeZone: ''
        },
        defaultItem: {
          id: -1,
          name: '',
          domainName: '',
          email: '',
          timeZone: ''
        },
        search: '',
        loading: false,
        headers: [
          {text: 'Id', align: 'left', sortable: true, value: 'id'},
          {text: 'Name', align: 'left', sortable: true, value: 'name'},
          {text: 'Domain', align: 'left', sortable: true, value: 'domainName'},
          {text: 'TimeZone', align: 'left', sortable: true, value: 'timeZone'},
          {text: 'SLA', align: 'left', sortable: true, value: 'sla'},
          {text: 'Created', align: 'left', sortable: true, value: 'createdDate'},
          {text: 'Updated', align: 'left', sortable: true, value: 'updatedDate'},
          {text: 'Deleted', align: 'left', sortable: true, value: 'deleted'},
          {text: 'Actions', align: 'left', sortable: false, value: 'actions'}
      ],
      slas: [
        {text: 'All', value: 0},
        {text: 'Paid', value: 1},
        {text: 'Trial', value: 10},
        {text: 'Self-Service Trial', value: 11},
        {text: 'Expired', value: 100},
        {text: 'CCO', value: 1000}
      ],
      deletedItems:[
        {text: 'All', value: null},
        {text: 'Deleted only', value: true},
        {text: 'Non-deleted only', value: false}
      ],
      deletedFilter: null,
      slaFilter: null,
      timeZEntries: Object.entries(TZ_DISPLAY_MAP_ORG).map((a,b) => {return {text:a[1], value:a[0]}}),
      newOrgDialog: false,
      validOrg: false,
      rules: {
        required: value => !!value || 'Required.',
        formatEmail: value => !value || this.validateEmailFormat(value)
      }
    }
  },
  computed: {
    ...mapGetters('user', {
        orgs: 'getOrganizations'
    }),
    filteredOrgs: {
      get() {
        var filter = {}
        if (this.deletedFilter !== null) {
          filter.deleted = this.deletedFilter
        }
        if (this.slaFilter) {
          filter.sla = this.slaFilter
        }
        return _.filter(this.orgs, filter)
      }
    },
    domainName: {
      get() {
        if (!this.editedItem.email) {
          return ''
        }
        return this.editedItem.email.substring(this.editedItem.email.indexOf('@') + 1)
      },
      set(val) {
        this.editedItem.domainName = val
      }
    }
  },
  async created () {
    this.refresh()
  },
  methods: {
    formatDateTime(val) {
      return moment(val).format('MM/DD/YYYY, h:mm:ss a')
    },
    async refresh() {
      this.loading = true
      await this.$store.dispatch('user/getOrganizations')
      this.loading = false
    },
    newOrg () {
      this.newOrgDialog = true
    },
    close() {
        this.newOrgDialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedId = -1
        }, 300)
    },
    async saveNew() {
      if (!this.$refs.orgForm.validate()) {
        return
      }
      this.editedItem.domainName = this.editedItem.email.substring(this.editedItem.email.indexOf('@') + 1)
      let response = await this.$store.dispatch('crossorg/createOrg', this.editedItem)
      this.close()
      this.refresh()
    },
    validateEmailFormat(value) {
      let regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return regexEmail.test(value) || 'Must be a valid email'
    }
  }
}
</script>
